import { Loader2 } from "lucide-react";

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    loading?: boolean;
    label?: string;
}

/** On/off toggle (used for user active / inactive) */
export default function Switch({ checked, onChange, disabled, loading, label }: SwitchProps) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={label}
            title={label}
            disabled={disabled || loading}
            onClick={(e) => {
                e.stopPropagation();
                onChange(!checked);
            }}
            className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
                checked ? "bg-emerald-500/80 border-emerald-400/40" : "bg-slate-800 border-slate-700"
            }`}
        >
            <span
                className={`inline-flex items-center justify-center h-4 w-4 rounded-full bg-white shadow transition-transform ${
                    checked ? "translate-x-6" : "translate-x-1"
                }`}
            >
                {loading && <Loader2 size={10} className="animate-spin text-slate-500" />}
            </span>
        </button>
    );
}